import axios from 'axios';

export const state = {}

export const getters = {}

export const mutations = {}


export const actions = {

  async apiPartnerDropDown({ commit, dispatch, getters }) {

    try{

      const result  = await axios.get('api-partners/drop-down');

      return { success: true, message: 'API-Partners', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },
}